import styled from 'styled-components';
import { Patient, Pharmacy } from '../api';
import { formatPhoneNumber } from '../utils';
import moment from 'moment';

export const PharmacyCard = (props: { pharmacy: Pharmacy }) => {
  const { pharmacy } = props;
  return (
    <Card>
      <CardTitle>{pharmacy.name}</CardTitle>
      <CardDataRow>
        <CardDataLabel>Address:</CardDataLabel>
        <CardDataElement>
          {pharmacy.address_line_1}
          <br />
          {pharmacy.city}, {pharmacy.state}
          <br />
          {pharmacy.zip}
        </CardDataElement>
      </CardDataRow>
      <CardDataRow>
        <CardDataLabel>Phone:</CardDataLabel>
        <CardDataElement>{formatPhoneNumber(pharmacy.phone)}</CardDataElement>
      </CardDataRow>
      <CardDataRow>
        <CardDataLabel>Fax:</CardDataLabel>
        <CardDataElement>{formatPhoneNumber(pharmacy.fax)}</CardDataElement>
      </CardDataRow>
      {pharmacy.name === 'Symphony Pharmacy' && (
        <CardDataRow>
          <CardDataLabel>Phone Tree Instructions:</CardDataLabel>
          <CardDataElement>ONLY CHOOSE OPTION 3 (Speak to a Pharmacy Team Member)</CardDataElement>
        </CardDataRow>
      )}
    </Card>
  );
};

export const PatientCard = (props: { patient: Patient }) => {
  const { patient } = props;
  return (
    <Card>
      <CardTitle>
        {patient.patient_last_name}, {patient.patient_first_name}
      </CardTitle>
      <CardDataRow>
        <CardDataLabel>DOB:</CardDataLabel>
        <CardDataElement>{moment(patient.patient_dob).format('MMMM D, YYYY')}</CardDataElement>
      </CardDataRow>
      <CardDataRow>
        <CardDataLabel>Address:</CardDataLabel>
        <CardDataElement>
          {patient.patient_address_line_1}
          <br />
          {patient.patient_address_city}, {patient.patient_address_state}
          <br />
          {patient.patient_address_postal_code}
        </CardDataElement>
      </CardDataRow>
      <CardDataRow>
        <CardDataLabel>Phone:</CardDataLabel>
        <CardDataElement>{formatPhoneNumber(patient.patient_phone)}</CardDataElement>
      </CardDataRow>
    </Card>
  );
};

export const TandemCard = () => {
  return (
    <Card>
      <CardTitle>Tandem Pharmacy</CardTitle>
      <CardDataRow>
        <CardDataLabel>NPI:</CardDataLabel>
        <CardDataElement>1508542689</CardDataElement>
      </CardDataRow>
      <CardDataRow>
        <CardDataLabel>Phone:</CardDataLabel>
        <CardDataElement>{formatPhoneNumber('2082540154')}</CardDataElement>
      </CardDataRow>
      <CardDataRow>
        <CardDataLabel>Fax:</CardDataLabel>
        <CardDataElement>{formatPhoneNumber('2082132108')}</CardDataElement>
      </CardDataRow>
    </Card>
  );
};

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin: 24px;
  justify-content: space-between;
`;

const Card = styled.div`
  display: flex;
  width: 300px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 2px;
`;

// TODO: use Typography component
const CardTitle = styled.h1`
  color: var(--grayscale-900);
  font-family: 'Space Grotesk', system-ui, Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 101%;
`;

const CardDataRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

// TODO: use Typography component
const CardDataLabel = styled.p`
  color: var(--grayscale-600);
  font-family: 'Space Grotesk', system-ui, Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

// TODO: use Typography component
const CardDataElement = styled.p`
  color: var(--grayscale-900);
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 101%; /* 14.14px */
  margin: 0;
`;
